<template>
  <div class="compressed-content">
    <h3>Have you EVER been told that you have diabetes or pre-diabetes (also called “borderline” diabetes”)?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.diabetesHistory">
      <b-form-checkbox v-model="survey.bloodSugar.diabetesHistory.toldNoDiabetes" 
                       @change="onNoDiabetesSelected">
        No
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodSugar.diabetesHistory.toldType1Diabetes" 
                       @change="onType1DiabetesSelected">
        Type 1 Diabetes
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodSugar.diabetesHistory.toldType2Diabetes"
                       @change="onType2DiabetesSelected">
        Type 2 Diabetes
      </b-form-checkbox>
      <b-form-checkbox v-model="survey.bloodSugar.diabetesHistory.toldPreDiabetes" 
                       @change="onPreDiabetesSelected">
        Pre-diabetic
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { anyOptionRequired } from 'utils/custom-validators';

  export default {
    mixins: [formMixin],

    validations: {
      diabetesHistory: {
        anyOptionRequired: anyOptionRequired((value) => value.toldNoDiabetes || value.toldType1Diabetes
          || value.toldType2Diabetes || value.toldPreDiabetes)
      }
    },

    computed: {
      ...mapState(["survey"]),

      diabetesHistory() { return this.survey.bloodSugar.diabetesHistory; }
    },

    methods: {
      onNoDiabetesSelected(value) {
        this.setOptions(value, false, false, false);
      },

      onType1DiabetesSelected(value) {
        this.setOptions(false, value, this.survey.bloodSugar.diabetesHistory.toldType2Diabetes,
          this.survey.bloodSugar.diabetesHistory.toldPreDiabetes);
      },

      onType2DiabetesSelected(value) {
        this.setOptions(false, this.survey.bloodSugar.diabetesHistory.toldType1Diabetes, value,
          this.survey.bloodSugar.diabetesHistory.toldPreDiabetes);
      },

      onPreDiabetesSelected(value) {
        this.setOptions(false, this.survey.bloodSugar.diabetesHistory.toldType1Diabetes,
          this.survey.bloodSugar.diabetesHistory.toldType2Diabetes, value);
      },

      setOptions(toldNoDiabetes, toldType1Diabetes, toldType2Diabetes, toldPreDiabetes) {
        this.survey.bloodSugar.diabetesHistory.toldNoDiabetes = toldNoDiabetes;
        this.survey.bloodSugar.diabetesHistory.toldType1Diabetes = toldType1Diabetes;
        this.survey.bloodSugar.diabetesHistory.toldType2Diabetes = toldType2Diabetes;
        this.survey.bloodSugar.diabetesHistory.toldPreDiabetes = toldPreDiabetes;
      }
    }
  };
</script>